module.exports = __webpack_public_path__ + "img/grade2.8d519bfa.png";